import { z } from 'zod';
/** Comma-separated list in the query string -> string[] (empty string -> undefined). */
const csv = z
    .string()
    .optional()
    .transform((s) => {
    if (!s)
        return undefined;
    const parts = s.split(',').map((p) => p.trim()).filter(Boolean);
    return parts.length ? parts : undefined;
});
const year = z.coerce.number().int().min(1900).max(2100).optional();
/**
 * Filter query accepted by every data endpoint.
 * Omitted list filters mean "no restriction". Omitted years mean the full range.
 */
export const FiltersQuery = z.object({
    indicator: z.string().min(1).describe('Indicator name, exactly as in /api/meta'),
    from: year.describe('First year, inclusive'),
    to: year.describe('Last year, inclusive'),
    region: csv.describe('Comma-separated region codes (AFR,EAP,...)'),
    income: csv.describe('Comma-separated income groups'),
    ownership: csv.describe('Comma-separated ownership values (Public,Private)'),
});
//# sourceMappingURL=filters.js.map